/* ==========================================================================
   Ure po meri — personalizator slider on the home page
   (sections/home-configurator.liquid).

   Each model is the real personalizator section, fetched from
   /products/<handle>?view=hcfg (templates/product.hcfg.liquid) and mounted in
   [data-hcfg-mount]. Its own scripts run as on the product page, so options,
   prices, the picking list on the order and "add to cart" are the same code —
   this file never decides what a valid watch is. It only:
     · fetches, mounts and swaps the personalizator, with a transition;
     · runs the model strip, the arrows, the swipe and the autoplay;
     · dresses the mounted watch: the bezel ring, tilt and glare.

   The personalizator scripts look their root up with document.querySelector,
   so exactly one is mounted at a time: the old one is removed before the next
   one's scripts run.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-hcfg]');
  if (!root || root.__hcfg) return;
  root.__hcfg = true;

  var MODELS; try { MODELS = JSON.parse(root.querySelector('[data-hcfg-models]').textContent); } catch (e) { return; }
  if (!MODELS || !MODELS.length) return;

  var $ = function (s) { return root.querySelector(s); };
  var mount = $('[data-hcfg-mount]'), tabsEl = $('[data-hcfg-tabs]'), ink = $('[data-hcfg-ink]');
  var idxEl = $('[data-hcfg-idx]'), totalEl = $('[data-hcfg-total]'), ringTpl = $('template[data-hcfg-ring]');
  var CALM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var WIDE = window.matchMedia('(min-width: 901px)');
  var html = {}, cur = -1, busy = 0, stage = null, stageIO = null;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function viewUrl(m) { return m.url + (m.url.indexOf('?') < 0 ? '?' : '&') + 'view=hcfg'; }
  function get(i) {
    var m = MODELS[i];
    return html[m.url] || (html[m.url] = fetch(viewUrl(m), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .catch(function (e) { delete html[m.url]; throw e; }));
  }
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  // ------------------------------------------------------------------ mounting
  // innerHTML does not run scripts, so each one is re-created in place, in
  // order; external ones are made non-async so they keep that order.
  function place(markup) {
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    mount.innerHTML = '';
    [].slice.call(doc.body.childNodes).forEach(function (n) { mount.appendChild(document.importNode(n, true)); });
    [].slice.call(mount.querySelectorAll('script')).forEach(function (old) {
      if (old.type && old.type !== 'text/javascript' && old.type !== 'module') return;   // JSON data stays as is
      var s = document.createElement('script');
      [].slice.call(old.attributes).forEach(function (a) { if (a.name !== 'defer' && a.name !== 'async') s.setAttribute(a.name, a.value); });
      if (old.src) s.async = false; else s.text = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
    dress();
  }

  // the bezel ring behind the watch, and tilt + glare on a mouse
  function dress() {
    stage = mount.querySelector('[data-cfg-stage]');
    if (!stage) return;
    // the studio personalizator (sections/configurator-studio.liquid) brings its own
    // ring, and its watch answers the pointer itself (parts light up), so no tilt
    var studio = !!stage.closest('[data-studio]');
    if (!studio && ringTpl && !stage.querySelector('.m-hcfg__ring')) stage.insertBefore(ringTpl.content.firstElementChild.cloneNode(true), stage.firstChild);
    if (!studio) { var glare = document.createElement('span'); glare.className = 'm-hcfg__glare'; glare.setAttribute('aria-hidden', 'true'); stage.appendChild(glare); }
    if (!studio && FINE && !CALM) {
      var raf = 0, px = 0, py = 0, st = stage;
      st.classList.add('can-tilt');
      st.addEventListener('pointermove', function (e) {
        var r = st.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width - 0.5; py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          st.style.setProperty('--hc-rx', (-py * 7).toFixed(2) + 'deg');
          st.style.setProperty('--hc-ry', (px * 9).toFixed(2) + 'deg');
          st.style.setProperty('--hc-gx', ((px + 0.5) * 100).toFixed(1) + '%');
          st.style.setProperty('--hc-gy', ((py + 0.5) * 100).toFixed(1) + '%');
        });
      });
      st.addEventListener('pointerleave', function () { st.style.setProperty('--hc-rx', '0deg'); st.style.setProperty('--hc-ry', '0deg'); });
    }
    // a horizontal swipe on the watch moves to the next model; a mostly
    // vertical one is left to the page so scrolling still works
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      // once a choice is made, a stray swipe must not throw the build away
      if (dirty) return;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });
    watchStage();
    pinTop();
    stage.addEventListener('load', queuePin, true);
  }

  // a choice made in the personalizator marks the build as the customer's own
  var dirty = false;
  mount.addEventListener('click', function (e) { if (e.target.closest('.m-cfg__opts, .m-cfg__addons, .upm-st__panel')) dirty = true; });
  mount.addEventListener('change', function () { dirty = true; });

  // The watch is pinned while the options scroll past it: on a phone with its
  // step bar (assets/upm-cfg.js), on a computer beside the options. On the home
  // page the header is fixed and shows or hides while scrolling, which neither
  // the theme nor that script sees — the watch slid under the header. Measure
  // the header as it moves; the CSS pins the watch just below it (--hc-head).
  var pinQueued = false;
  function pinTop() {
    pinQueued = false;
    var w = document.querySelector('.m-header__wrapper'), h = 0;
    if (w && /fixed|sticky/.test(getComputedStyle(w).position)) h = Math.max(0, Math.round(w.getBoundingClientRect().bottom));
    root.style.setProperty('--hc-head', h + 'px');
    // on a computer the watch is pinned in the middle of the screen below the
    // header, never closer to it than 20px
    var p0 = mount.querySelector('.m-cfg__preview');
    if (p0) p0.style.top = WIDE.matches ? h + Math.max(20, Math.round((window.innerHeight - h - p0.offsetHeight) / 2)) + 'px' : '';
    var c = mount.querySelector('.m-cfg--stepped'); if (!c) return;
    c.style.setProperty('--upm-cfg-top', h + 'px');
    var pv = c.querySelector('.m-cfg__preview');
    if (pv) c.style.setProperty('--upm-cfg-preview', pv.offsetHeight + 'px');
  }
  function queuePin() { if (!pinQueued) { pinQueued = true; requestAnimationFrame(pinTop); } }
  window.addEventListener('scroll', queuePin, { passive: true });
  window.addEventListener('resize', queuePin);

  // ------------------------------------------------------------- model change
  function show(i, quiet) {
    var dir = i > cur ? 1 : -1;
    i = (i + MODELS.length) % MODELS.length;
    if (i === cur && mount.querySelector('[data-cfg]')) return;
    cur = i;
    if (idxEl) idxEl.textContent = pad(cur + 1);
    root.style.setProperty('--hc-rot', (cur * -30) + 'deg');
    root.style.setProperty('--hc-dir', dir);
    tabsEl.querySelectorAll('[data-i]').forEach(function (b) {
      var on = +b.dataset.i === cur; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && tabsEl.scrollWidth > tabsEl.clientWidth) {
        tabsEl.scrollTo({ left: b.offsetLeft - tabsEl.clientWidth / 2 + b.clientWidth / 2, behavior: CALM ? 'auto' : 'smooth' });
      }
    });
    moveInk();
    if (!quiet) restartTimer();

    dirty = false;
    var n = ++busy, hadOne = !!mount.querySelector('[data-cfg]');
    // keep the height while the next model loads, so the page does not jump
    if (hadOne) mount.style.minHeight = mount.offsetHeight + 'px';
    if (hadOne && !CALM) mount.classList.add('is-out');
    Promise.all([get(cur), hadOne && !CALM ? wait(280) : null]).then(function (r) {
      if (n !== busy) return;
      place(r[0]);
      mount.classList.remove('is-out');
      if (!CALM) { mount.classList.add('is-in'); void mount.offsetWidth; mount.classList.remove('is-in'); }
      setTimeout(function () { if (n === busy) mount.style.minHeight = ''; }, 700);
      // the next model is likely to be wanted next; fetch it while idle
      var nx = (cur + 1) % MODELS.length;
      (window.requestIdleCallback || setTimeout)(function () { get(nx).catch(function () {}); });
    }).catch(function () {
      if (n !== busy) return;
      mount.classList.remove('is-out'); mount.style.minHeight = '';
      // without the embedded personalizator the product page still works
      mount.innerHTML = '<p class="m-hcfg__fail"><a href="' + esc(MODELS[cur].url) + '">' + esc(MODELS[cur].name) + ' →</a></p>';
    });
  }

  // the underline slides to the active name
  function moveInk() {
    var b = tabsEl.querySelector('.is-on'); if (!b || !ink) return;
    ink.style.width = b.offsetWidth + 'px';
    ink.style.transform = 'translateX(' + b.offsetLeft + 'px)';
  }

  // ----------------------------------------------------------------- autoplay
  // Until the visitor touches anything, the slider walks through the models on
  // its own; the bar under the active name shows how long until the next one.
  // The first interaction stops it for good. It runs only while the watch
  // itself is on screen — on a phone the options sit below it, and a model
  // must not change under someone who is choosing.
  var AUTO = 7000, timer = null, auto = !CALM, onScreen = false;
  function restartTimer() {
    clearTimeout(timer);
    root.classList.remove('is-ticking');
    if (!auto || !onScreen) return;
    void root.offsetWidth; root.classList.add('is-ticking');
    root.style.setProperty('--hc-auto', AUTO + 'ms');
    timer = setTimeout(function () {
      // never move on from a watch the visitor has started building
      if (dirty) { stopAuto(); return; }
      show(cur + 1, true); restartTimer();
    }, AUTO);
  }
  function stopAuto() { if (!auto) return; auto = false; clearTimeout(timer); root.classList.remove('is-ticking'); }
  ['pointerdown', 'keydown', 'wheel', 'touchstart', 'click', 'change'].forEach(function (ev) { root.addEventListener(ev, stopAuto, { passive: true }); });
  function watchStage() {
    if (!('IntersectionObserver' in window) || !stage) return;
    if (!stageIO) stageIO = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        onScreen = x.isIntersecting;
        if (onScreen) restartTimer(); else { clearTimeout(timer); root.classList.remove('is-ticking'); }
      });
    }, { threshold: 0.6 });
    stageIO.disconnect(); stageIO.observe(stage);
  }

  // ------------------------------------------------------------------- events
  tabsEl.insertAdjacentHTML('beforeend', MODELS.map(function (m, i) {
    return '<button type="button" role="tab" class="m-hcfg__tab" data-i="' + i + '">' + esc(m.name) + '</button>'; }).join(''));
  if (totalEl) totalEl.textContent = pad(MODELS.length);
  tabsEl.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) show(+b.dataset.i); });
  $('[data-hcfg-prev]').addEventListener('click', function () { show(cur - 1); });
  $('[data-hcfg-next]').addEventListener('click', function () { show(cur + 1); });
  window.addEventListener('resize', moveInk);
  // "Start over" in the studio: the same model, mounted again from scratch
  mount.addEventListener('upm-hcfg:reset', function () { get(cur).then(function (h) { dirty = false; place(h); }); });

  // The personalizator is not fetched until the section is close to the
  // screen, so the home page pays nothing for it on first load.
  var started = false;
  function start() { if (started) return; started = true; show(0, true); requestAnimationFrame(moveInk); }
  if ('IntersectionObserver' in window) {
    if (!CALM) root.classList.add('is-armed');
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { start(); root.classList.add('is-in'); } });
    }, { threshold: 0.12 }).observe(root);
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) start(); });
    }, { rootMargin: '600px 0px' }).observe(root);
  } else { start(); root.classList.add('is-in'); }

  // "Build your watch" (hero, the fork, the steps) goes to the list of
  // personalizators, as its link says — the owner wants the collection, not a
  // scroll down to this section (2026-10-27).
})();
